import { render, staticRenderFns } from "./PowraH.vue?vue&type=template&id=7b1b07f8&"
import script from "./PowraH.vue?vue&type=script&lang=js&"
export * from "./PowraH.vue?vue&type=script&lang=js&"
import style0 from "./PowraH.vue?vue&type=style&index=0&id=7b1b07f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports